import { TFunction } from 'i18next';

export const TAGS_NOTIFICATION = {
  CREATE_SUCCESS: 'Tag Created Successfully',
  UPDATE_SUCCESS: 'Tag Updated Successfully',
};
export const TagsColumnWidth = {
  name: '50%',
  products_in_tag: '30%',
  action: '20%',
};

export const TAG_DISPLAY_LIMIT = 25;

export const ActiveStatusOptions = (t: TFunction) => [
  { label: t('Active'), value: '1' },
  { label: t('Inactive'), value: '0' },
];

export const TagTypes = (t: TFunction) => [
  {
    options: [
      { label: t('TagType_Items'), value: 'items' },
      // { label: t('TagType_Sales'), value: 'sales' },
      // { label: t('TagType_Receiving'), value: 'receiving' },
      // {
      //   label: t('TagType_Customer'),
      //   value: 'customer',
      // },
    ],
  },
];

export const TagButtonIconSize = '20px';
export const TagActionButtons = {
  button: {
    width: '30px',
    height: '30px',
  },
  icon: '20px',
};
